// Unique, Bangkok-targeted content for the hotel flower delivery landing page (RU/EN only).
// Written from scratch — NOT a copy of the Istanbul page.
export const BANGKOK_HOTEL_PRODUCT_IDS = [
  "afd91106-71c8-40fc-99ec-42eec36f90e7",
  "6c7851d9-a95d-42ef-a47e-a826b282bea1",
  "cf3a341e-88b1-4ccc-a2bb-2a03db652021",
  "250889f5-9285-4571-961e-e74f81376373",
  "b788054c-117e-480d-8b59-ed7877ee5de7",
  "dd997f36-d47b-4b57-a390-72c9c183e034",
  "a68026f3-2412-4061-9262-322b6db46acb",
  "1a4e3122-57d3-4adc-8120-c1dfaf15d673",
];

// Product ids are generated per-environment at seed time, so we select the curated
// hotel bouquets by their stable Russian name (identical across preview and production).
export const BANGKOK_HOTEL_PRODUCT_NAMES = [
  "Городской Рассвет",
  "Шёлковый Бангкок",
  "Тропический Муссон",
  "Золотой Храм",
  "Королевский Жасмин",
  "Сиамский Закат",
  "Императорский Лотос",
  "Золотая Пагода",
];

export const bangkokHotelContent = {
  ru: {
    metaTitle: "Доставка цветов в отели Бангкока — букет в номер к приезду | YUCCA",
    metaDescription:
      "Доставка цветов в отели Бангкока: букет в номер к заезду, сюрприз к годовщине, оформление для гостей. Отели на Сукхумвите, Силоме, Сатхорне и набережной Чао Прая. Фото перед вручением, оплата из любой страны. Заказ в WhatsApp.",
    waCity: "в Бангкоке",
    breadcrumb: { home: "Главная", city: "Бангкок", current: "Цветы в отели" },
    h1: "Доставка цветов в отели Бангкока",
    heroLead:
      "Хотите, чтобы букет ждал в номере к приезду близкого человека, встретил гостей на ресепшене или стал сюрпризом к годовщине в отеле Бангкока? YUCCA Flowers доставляет свежие цветы в отели по всему городу — от Сукхумвита и набережной Чао Прая до делового Силома и Сатхорна. Мы согласуем вручение с ресепшеном или консьержем и пришлём фото букета перед доставкой.",
    heroBullets: [
      "Букет в номер к заезду или к возвращению вечером",
      "Вручение через ресепшен, консьержа или напрямую гостю",
      "Отели на Сукхумвите, у реки, в Силоме и Сатхорне, у Сиама",
      "Учитываем пробки — доставляем точно к нужному времени",
      "Фото готового букета до вручения",
      "Оплата картой любой страны, криптовалютой или переводом",
    ],
    cta: "Выбрать букет в отель",
    catalogHeading: "Букеты, которые чаще всего заказывают в отели",
    catalogNote: "Стойкие к тропическому климату композиции — цены в долларах США.",
    fullCatalog: "Смотреть весь каталог Бангкока →",
    sections: [
      {
        h2: "Как мы доставляем цветы в отели Бангкока",
        answer:
          "Мы привозим букет прямо в отель и согласуем вручение так, как удобно вам: в номер, на ресепшен или лично гостю в оговорённое время.",
        paras: [
          "Достаточно указать название отеля, район и имя гостя (или номер брони). Для сюрприза доставим, не раскрывая отправителя, — просто оставьте контакт получателя, и курьер аккуратно всё организует.",
          "Бангкок большой и с плотным трафиком, поэтому для доставки к точному времени — например, к заезду или к ужину — лучше оформить заказ заранее. Перед выездом курьера пришлём фото готовой композиции.",
        ],
        table: {
          head: ["Район отелей", "Ориентир", "Срок в день заказа"],
          rows: [
            ["Сукхумвит (Асок, Тонглор, Эккамай)", "деловые и бутик-отели", "1–2 часа"],
            ["Силом и Сатхорн", "пятизвёздочные и бизнес-отели", "1–2 часа"],
            ["Набережная Чао Прая", "речные и панорамные отели", "1–3 часа"],
            ["Сиам и Пратунам", "отели у торговых центров", "1–2 часа"],
            ["Раттанакосин, Чайна-таун", "бутик- и гостевые дома", "2–3 часа"],
          ],
        },
      },
      {
        h2: "Поводы заказать цветы в отель в Бангкоке",
        answer:
          "Чаще всего к нам обращаются, чтобы сделать приезд или особый день в отеле по-настоящему запоминающимся.",
        bullets: [
          "Романтический сюрприз к заезду пары — букет и лепестки в номере",
          "Годовщина или предложение руки и сердца в отеле у реки",
          "Встреча гостя из аэропорта — цветы уже ждут в номере",
          "Деловой приём партнёра в отеле Силома или Сатхорна",
          "День рождения на отдыхе — композиция и открытка к завтраку",
        ],
        note: "Добавим открытку, шары или сладости по запросу и согласуем момент вручения.",
      },
    ],
    glanceTitle: "Коротко о доставке в отели",
    glance: [
      { label: "Куда", value: "Отели по всему Бангкоку" },
      { label: "Сроки", value: "В день заказа, 1–3 часа" },
      { label: "Цены", value: "Букеты от $92, премиум от $512" },
      { label: "Вручение", value: "В номер, на ресепшен или гостю" },
      { label: "Оплата", value: "Карта, крипто, перевод — из любой страны" },
      { label: "Контроль", value: "Фото букета перед доставкой" },
    ],
    faqTitle: "Частые вопросы о доставке цветов в отели Бангкока",
    faq: [
      { q: "Доставите ли вы букет прямо в номер отеля?", a: "Да. Мы согласуем с ресепшеном или консьержем вручение в номер, либо передадим букет гостю лично в оговорённое время. Укажите название отеля, район и имя гостя или номер брони." },
      { q: "Можно ли сделать сюрприз, чтобы гость не знал заранее?", a: "Да. Оставьте контакт получателя — курьер деликатно всё организует и не раскроет отправителя. По желанию открытку оставим анонимной или подпишем как вы попросите." },
      { q: "В какие отели Бангкока вы возите цветы?", a: "В отели по всему городу: Сукхумвит (Асок, Тонглор, Эккамай), Силом и Сатхорн, набережную Чао Прая, район Сиам и Пратунам, а также бутик-отели Раттанакосина и Чайна-тауна." },
      { q: "Сколько стоит букет в отель?", a: "Компактные букеты — от $92, средние — $265–492, премиальные из орхидей и роз — от $512. Доставка по городу обычно включена. Цены в долларах США." },
      { q: "Как быстро доставите?", a: "По центральным районам — обычно за 1–2 часа после подтверждения, по набережной и удалённым отелям — за 1–3 часа. Из-за пробок для доставки к точному времени лучше заказать заранее." },
      { q: "Как оплатить из другой страны?", a: "Картой любого банка мира, криптовалютой или переводом. Заказать сюрприз в отель Бангкока можно из любой точки мира, ещё до прибытия." },
    ],
    relatedTitle: "Смотрите также",
    related: [
      { label: "Каталог цветов в Бангкоке", href: "/bangkok" },
      { label: "Как заказать цветы в Бангкоке", href: "/blog/kak-zakazat-cvety-v-bangkoke" },
      { label: "Цветы в Пхукете", href: "/phuket" },
      { label: "Цветы в Паттайе", href: "/pattaya" },
    ],
  },
  en: {
    metaTitle: "Flower Delivery to Bangkok Hotels — Bouquet in the Room | YUCCA",
    metaDescription:
      "Flower delivery to Bangkok hotels: a bouquet in the room on arrival, an anniversary surprise, styling for guests. Hotels on Sukhumvit, Silom, Sathorn and the Chao Phraya riverside. Photo before hand-over, payment from any country. Order on WhatsApp.",
    waCity: "in Bangkok",
    breadcrumb: { home: "Home", city: "Bangkok", current: "Flowers to Hotels" },
    h1: "Flower Delivery to Bangkok Hotels",
    heroLead:
      "Want a bouquet waiting in the room when a loved one arrives, greeting guests at reception, or surprising someone for an anniversary at a Bangkok hotel? YUCCA Flowers delivers fresh flowers to hotels across the whole city — from Sukhumvit and the Chao Phraya riverside to business Silom and Sathorn. We coordinate hand-over with reception or the concierge and send a photo of the bouquet before delivery.",
    heroBullets: [
      "A bouquet in the room on arrival or for the evening return",
      "Hand-over via reception, the concierge or directly to the guest",
      "Hotels on Sukhumvit, by the river, in Silom and Sathorn, near Siam",
      "We account for traffic — delivering exactly on time",
      "A photo of the finished bouquet before hand-over",
      "Payment by card from any country, crypto or transfer",
    ],
    cta: "Choose a bouquet for the hotel",
    catalogHeading: "Bouquets Most Often Ordered to Hotels",
    catalogNote: "Arrangements hardy to the tropical climate — prices in US dollars.",
    fullCatalog: "See the full Bangkok catalog →",
    sections: [
      {
        h2: "How We Deliver Flowers to Bangkok Hotels",
        answer:
          "We bring the bouquet straight to the hotel and arrange hand-over however suits you: to the room, at reception, or in person to the guest at an agreed time.",
        paras: [
          "Just give the hotel name, the district and the guest's name (or booking number). For a surprise we deliver without revealing the sender — simply leave the recipient's contact and the courier arranges everything discreetly.",
          "Bangkok is large and its traffic is heavy, so for delivery at a precise time — for arrival or dinner, say — it's best to order ahead. Before the courier sets off we send a photo of the finished arrangement.",
        ],
        table: {
          head: ["Hotel area", "Type", "Same-day timing"],
          rows: [
            ["Sukhumvit (Asok, Thonglor, Ekkamai)", "business & boutique hotels", "1–2 hours"],
            ["Silom and Sathorn", "five-star & business hotels", "1–2 hours"],
            ["Chao Phraya riverside", "riverside & panoramic hotels", "1–3 hours"],
            ["Siam and Pratunam", "hotels by the malls", "1–2 hours"],
            ["Rattanakosin, Chinatown", "boutique & guest houses", "2–3 hours"],
          ],
        },
      },
      {
        h2: "Occasions to Send Flowers to a Bangkok Hotel",
        answer:
          "Most people come to us to make an arrival or a special day at the hotel truly memorable.",
        bullets: [
          "A romantic surprise for a couple's arrival — bouquet and petals in the room",
          "An anniversary or a marriage proposal at a riverside hotel",
          "Greeting a guest from the airport — flowers already waiting in the room",
          "A business welcome for a partner at a Silom or Sathorn hotel",
          "A birthday on holiday — an arrangement and card for breakfast",
        ],
        note: "We'll add a card, balloons or sweets on request and coordinate the moment of hand-over.",
      },
    ],
    glanceTitle: "Hotel Delivery at a Glance",
    glance: [
      { label: "Where", value: "Hotels across all of Bangkok" },
      { label: "Timing", value: "Same-day, 1–3 hours" },
      { label: "Prices", value: "Bouquets from $92, premium from $512" },
      { label: "Hand-over", value: "To the room, reception or the guest" },
      { label: "Payment", value: "Card, crypto, transfer — from any country" },
      { label: "Control", value: "Photo of the bouquet before delivery" },
    ],
    faqTitle: "FAQ — Flower Delivery to Bangkok Hotels",
    faq: [
      { q: "Will you deliver the bouquet straight to the hotel room?", a: "Yes. We coordinate room delivery with reception or the concierge, or hand the bouquet to the guest in person at an agreed time. Give the hotel name, district and the guest's name or booking number." },
      { q: "Can I make it a surprise so the guest doesn't know?", a: "Yes. Leave the recipient's contact — the courier arranges everything discreetly and won't reveal the sender. On request we keep the card anonymous or sign it as you wish." },
      { q: "Which Bangkok hotels do you deliver to?", a: "Hotels across the whole city: Sukhumvit (Asok, Thonglor, Ekkamai), Silom and Sathorn, the Chao Phraya riverside, Siam and Pratunam, plus boutique hotels in Rattanakosin and Chinatown." },
      { q: "How much does a bouquet to a hotel cost?", a: "Compact bouquets from $92, medium $265–492, premium orchid-and-rose arrangements from $512. City delivery is usually included. Prices are in US dollars." },
      { q: "How fast can you deliver?", a: "To central districts usually within 1–2 hours of confirmation, and 1–3 hours to the riverside and outer hotels. Because of traffic, for a precise time it's best to order ahead." },
      { q: "How can I pay from abroad?", a: "By card from any bank worldwide, cryptocurrency or transfer. You can arrange a surprise to a Bangkok hotel from anywhere in the world, even before you arrive." },
    ],
    relatedTitle: "See Also",
    related: [
      { label: "Bangkok flower catalog", href: "/bangkok?lang=en" },
      { label: "How to order flowers in Bangkok", href: "/blog/kak-zakazat-cvety-v-bangkoke?lang=en" },
      { label: "Flowers in Phuket", href: "/phuket?lang=en" },
      { label: "Flowers in Pattaya", href: "/pattaya?lang=en" },
    ],
  },
};
